import type React from 'react';

import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

import Facility from 'assets/icons/icn _ 24px _ Facility.svg?react';
import Reload from 'assets/icons/icon-reload-20-px.svg?react';
import Error500 from 'assets/images/500-error-graphic.png';
import Logo from 'assets/images/tournament-desk-logo.svg?react';
import LinkButton from 'components/buttons/LinkButton';
import { BodyXLarge, H1 } from 'components/typography/Typography';

import { useStyles } from './styles';

interface ErrorPageProps {
  error?: any;
  errorId?: string;
  type?: 'server' | 'react';
}

const ErrorPage: React.FC<React.PropsWithChildren<ErrorPageProps>> = ({ type = 'server', errorId }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      className={classes.container}
      direction="column"
      gap={2}
      justifyContent="center"
    >
      <Grid item className={classes.logo}>
        <Logo />
      </Grid>

      <Grid item className={classes.errorImage}>
        <img src={Error500} />
      </Grid>

      <Grid item>
        <H1 className={classes.text}>
          {`${type === 'react' ? t('errorPage.unexpectedError') : t('errorPage.serverError')}`}
        </H1>
        <BodyXLarge className={classes.text}>
          {type === 'react' ? (
            <>
              <span>
                {`${t('errorPage.logError')}`}
                <br />
                {`${t('errorPage.refError')}`}:
              </span>
              <blockquote className={classes.errorBlock}>{errorId || `${t('unk')}`}</blockquote>
            </>
          ) : (
            `${t('errorPage.fixError')}`
          )}
        </BodyXLarge>
      </Grid>

      <Grid container item className={classes.actions} gap={2} justifyContent="center">
        <LinkButton startIcon={<Reload />} onClick={() => window.location.reload()}>
          {`${t('refresh')}`}
        </LinkButton>
        <Divider flexItem className={classes.divider} orientation="vertical" />
        <LinkButton startIcon={<Facility />} onClick={() => window.location.replace('/')}>
          {`${t('tournamentHome')}`}
        </LinkButton>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
